<template>
  <div class="pb-90">
    <div class="relative">

      <section v-if="short" ref="geometry" class="frame-wrapper geometry-section tabsBox">
        <div class="wrapper">
          <p v-if="!isAryon" class="fs-36 bold color-black desktop-hide">
            {{ trans['geometry_table'] }}
          </p>
          <geometry v-if="!isAryon" :trans="trans" :model="modelSlug" :not-select-size="true"/>

          <div v-if="isAryon" class="nav-tabs desktop-hide">
            <div class="nav-item">
              <a
                :class="activeTabClass('first')"
                class="nav-link fs-36"
                @click.prevent="selectTab('first')"
              >
                {{ modelTitle('first') }}
              </a>
            </div>
            <div class="nav-item">
              <a
                :class="activeTabClass('second')"
                class="nav-link fs-36"
                @click.prevent="selectTab('second')"
              >
                {{ modelTitle('second') }}
              </a>
            </div>
          </div>
          <div v-if="isAryon" class="tabs">
            <div v-if="activeTabClass('first').active" class="tab">
              <geometry :model="aryonModelSlug(false)" :not-select-size="true"/>
            </div>
            <div v-if="activeTabClass('second').active" class="tab">
              <geometry :model="aryonModelSlug(true)" :not-select-size="true"/>
            </div>
          </div>
        </div>
      </section>

      <section
        :style="secondTitleStyles"
        class="second-title"
      >
        <div v-if="short" class="wrapper">
          <p class="fs-36 bold">
            {{ trans['spec_and_kits'] }}
          </p>
        </div>
      </section>

      <section
        :class="cardSectionClass"
        :style="cardTop"
        class="comparison-wrapper cards-section"
      >
        <div class="wrapper">
          <div ref="fixedBlock" class="stickyBox">
            <div class="grid-3">
              <div v-for="number in [1, 2, 3]" :key="number" :class="hiddenCard(number)">
                <div v-if="showCard(number)" class="cardComp">
                  <div class="cardComp-h" @click="showDropDown($event, number)">
                    <div :class="dropDownActive(number)" class="select-selection">
                      <p class="fs-24 bold color-black">{{ buildTitle(number) }}</p>
                      <p class="fs-12 color-dark">{{ selectorSubTitle }}</p>
                    </div>

                    <div
                      v-if="!short || number === 3"
                      :class="dropDownActive(number)"
                      class="select-dropdown"
                    >
                      <div v-for="modelItem in sortedModels" class="group">
                        <p class="fs-17">{{ modelItem.model }}</p>
                        <ul>
                          <li
                            v-for="item in sortedTitles(modelItem)"
                            :class="dropDownItemClass(item, number, modelItem)"
                          >
                            <!--                            <a-->
                            <!--                              v-if="modelItem.id !== model.id && short"-->
                            <!--                              :href="`/en/compare/${modelItem.slug}/all`"-->
                            <!--                              class="link"-->
                            <!--                              target="_blank"-->
                            <!--                            >-->
                            <!--                              <span class="name">{{ item.title }}</span>-->
                            <!--                              <span class="price">-->
                            <!--                              {{ $crConverter(item.price / 100, 'EUR') }}-->
                            <!--                            </span>-->
                            <!--                            </a>-->
                            <div
                              class="link"
                              @click="selectBuild(modelItem, item, number)"
                            >
                              <span class="name">{{ item.title }}</span>
                              <span class="price">
                              {{ $crConverter(item.price / 100, 'EUR') }}
                            </span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <ul v-else :class="dropDownActive(number)" class="select-container">
                      <li
                        v-for="item in shortModelList(number)"
                        :key="item.id"
                        :class="dropDownItemClass(item, number)"
                        @click="selectBuild(null, item, number)"
                      >
                        <p class="fs-24 bold color-black">{{ item.title }}</p>
                        <p class="fs-12 color-dark">{{ item['sub_title'] }}</p>
                      </li>
                    </ul>
                  </div>

                  <div
                    v-if="showCard(number)"
                    ref="cardCenter"
                    :style="cardSectionStyle"
                    class="cardComp-c"
                  >
                    <div class="card-center-wrap">
                      <div class="img-wrap">
                        <img
                          :alt="buildTitle(number)"
                          :src="buildImage(number)"
                          @click="showGallery(number)"
                        >
                      </div>
                      <div class="selectColor">
                        <div
                          v-for="colorGroup in modelColorGroups(number)"
                          :key="colorGroup.id"
                          class="group"
                        >
                          <div
                            v-for="color in colorGroup.colors"
                            :key="color.id"
                            class="item"
                          >
                            <input
                              :id="`color-${color.id}-group-${colorGroup.id}-${number}`"
                              :checked="isColorChecked(number, color)"
                              title="`Color switcher"
                              type="radio"
                              @click="selectBuildByColor(color, number)"
                            >
                            <label :for="`color-${color.id}-group-${colorGroup.id}-${number}`">
                              <img :alt="color.title" :src="color.image">
                            </label>
                          </div>
                          <p class="color-dark">{{ colorGroup.title }} <span>{{ colorGroupPrice(colorGroup) }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="outOfStock(number)" class="cardComp-f">
                    <p class="cardComp__text">
                      {{ trans['out_of_stock'] }}
                    </p>
                    <a
                      :href="toContacts(number)"
                      class="btn btn-outline"
                      target="_blank"
                    >
                      {{ trans['contact_us'] }}
                    </a>
                    <a :href="modelLink(number)" class="btn btn-arr">
                      {{ trans['learn_more_about_model'] }}
                      <svg data-v-263d2a82="" fill="none" height="12" viewBox="0 0 8 12" width="8"
                           xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.999999 11.4531L6 6.45313L1 1.45312" data-v-263d2a82="" stroke="black"
                              stroke-width="1.5"></path>
                      </svg>
                    </a>
                  </div>
                  <div v-else-if="model.purchasable" class="cardComp-f">
                    <p class="cardComp__text">
                      {{ $crConverter(buildPrice(number) / 100, 'EUR') }}
                    </p>
                    <button
                      class="btn btn-green"
                      @click.prevent="toChoose(number)"
                    >
                      {{ trans['order'] }}
                    </button>
                  </div>
                </div>
              </div>

              <div v-if="showAddingCompareModelCard" class="cardComp empty">
                <div class="cardComp-h" @click="showDropDown($event, 4)">
                  <div :class="dropDownActive(4)" class="select-selection">
                    <p class="fs-24 bold color-black">{{ compareText }}</p>
                    <p class="fs-12 color-dark">{{ compareSubText }}</p>
                  </div>
                  <div
                    :class="dropDownActive(4)"
                    class="select-dropdown"
                  >
                    <div v-for="modelItem in sortedModels" class="group">
                      <p class="fs-17">{{ modelItem.model }}</p>
                      <ul>
                        <li v-for="item in sortedTitles(modelItem)">
                          <a
                            v-if="modelItem.id !== model.id && short"
                            :href="`/en/compare/${modelItem.slug}/all`"
                            class="link"
                            target="_blank"
                          >
                            <span class="name">{{ item.title }}</span>
                            <span class="price">
                              {{ $crConverter(item.price / 100, 'EUR') }}
                            </span>
                          </a>
                          <div
                            v-else
                            class="link"
                            @click="selectNext(modelItem, item)"
                          >
                            <span class="name">{{ item.title }}</span>
                            <span class="price">
                              {{ $crConverter(item.price / 100, 'EUR') }}
                            </span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  ref="cardCenterEmpty"
                  :style="cardSectionStyle"
                  class="cardComp-c"
                >
                  <div class="card-center-wrap">
                    <div class="img-wrap">
                      <img alt="" src="/assets/images/builds/picture-stub.png">
                    </div>
                    <div class="text-wrap">
                      <p class="fs-14 bold">
                        {{ trans['compare_with_other'] }}
                      </p>
                      <p class="fs-12">
                        {{ trans['select_any_bike'] }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="plug"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        :style="specStyles"
        class="comparison-wrapper spec-section mb-0"
      >
        <div class="wrapper">
          <div v-if="compareBuild1" id="gridWrapper" class="grid-wrapper">
            <div v-for="spec in sortedSpecs" :key="spec.id" class="grid-3">
              <div class="col x-3">
                <div class="titleComp">
                  <img :alt="spec['common_title']" :src="specIcon(spec)" class="ic">
                  <p class="text">{{ commonTitle(spec) }}</p>
                  <hr>
                </div>
              </div>
              <div :class="specColumnClass(spec)" class="col">
                <div class="text-wrap">
                  <p :class="specTitleClass(spec)" class="fs-17">{{ spec.title }}</p>
                  <p :class="specDescriptionClass(spec)">{{ spec.description }}</p>
                </div>
              </div>
              <div v-if="!sameSpec(spec) && !isMobile" class="col">
                <div class="text-wrap">
                  <p :class="specTitleClass(getSameSpec(spec, 2))" class="fs-17">
                    {{ specTitle(spec, 2) }}
                  </p>
                  <p :class="specDescriptionClass(getSameSpec(spec, 2))">
                    {{ specDescription(spec, 2) }}
                  </p>
                </div>
              </div>
              <div v-if="!sameSpec(spec) && notSameWithBefore(spec, 2, 3)" class="col">
                <div class="text-wrap">
                  <p :class="specTitleClass(getSameSpec(spec, 3))" class="fs-17">
                    {{ specTitle(spec, 3) }}
                  </p>
                  <p :class="specDescriptionClass(getSameSpec(spec, 3))">
                    {{ specDescription(spec, 3) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        :class="titleClass"
        :style="titleStyle"
        class="fixTopLine"
      >
        <div class="wrapper">
          <div class="flex">
            <div v-if="isAryon && short" class="nav-tabs mobile-hide">
              <div class="nav-item">
                <a
                  :class="activeTabClass('first')"
                  class="nav-link fs-36"
                  @click.prevent="selectTab('first')"
                >
                  {{ modelTitle('first') }}
                </a>
              </div>
              <div class="nav-item">
                <a
                  :class="activeTabClass('second')"
                  class="nav-link fs-36"
                  @click.prevent="selectTab('second')"
                >
                  {{ modelTitle('second') }}
                </a>
              </div>
            </div>
            <p v-if="short && !isAryon" class="fs-24 bold color-black"><span class="mobile-hide">Geometry</span>
              {{ pageTitle }}</p>
            <p v-if="!short" class="fs-24 bold color-black">Models compare</p>
            <a class="btn btn-gray color-black ml-auto" href="#" @click.prevent="goBack()">{{ trans['go_back'] }}</a>
            <a v-if="short && model.purchasable" class="btn btn-green" href="/en/choose">{{ trans['order'] }}</a>
          </div>
        </div>
      </section>

      <section class="group-fix-btn">
        <div class="wrapper">
          <div v-for="number in [1, 3]" class="item">
            <div v-if="showCard(number) && outOfStock(number)">
              <p class="text">Out of stock</p>
              <a :href="toContacts(number)"
                 class="btn btn-outline"
                 target="_blank">
                {{ trans['contact_us'] }}
              </a>
            </div>
            <div v-if="showCard(number) && !outOfStock(number)" class="cardComp-f">
              <p class="text">{{ $crConverter(buildPrice(number) / 100, 'EUR') }}</p>
              <button class="btn btn-green" @click.prevent="toChoose(number)">
                {{ trans['order'] }}
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <carousel-models-vue :trans="trans" :models="carouselModels"/>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import ModelsCarousel from "./parts/ModelsCarousel";
import GeometryTable from "./parts/GeometryTable";

export default {
  name: 'Compare',
  components: {
    geometry: GeometryTable,
    'carousel-models-vue': ModelsCarousel
  },
  props: ['minBuild', 'midBuild', 'maxBuild', 'model', 'models', 'short', 'referer', 'translates', 'isMuscular'],
  data() {
    return {
      tabs: {
        first: true,
        second: false,
      },
      dropDowns: {
        1: false,
        2: false,
        3: false,
        4: false,
      },
      buildsList: [],
      lastScrollPosition: 0,
      currentScrollPosition: 0,
      scrollDiff: 0,
      scrollDirection: null,
      selectedTitle: null,
      selectedColor: null,
      cardHeight: 0,
      defaultCardHeight: 0,
      currentCardHeight: null,
      marginBottom: 0,
      cardCenterHeight: 0,
      titleHeight: 0,
      secondTitleHeight: 0,
      headerHeight: 0,
      geometryHeight: 0,
      title: null,
      secondTitle: null,
      titleTop: 80,
      header: null,
      geometry: null,
      cardSection: null,
      cardElement: null,
      specElement: null,
      screenWidth: 0
    }
  },
  computed: {
    ...mapGetters({
      compareBuild1: 'build/compareBuild1',
      compareBuild2: 'build/compareBuild2',
      compareBuild3: 'build/compareBuild3'
    }),
    trans() {
      return this.translates.text.compare
    },
    pageTitle() {
      return this.model.model
    },
    modelSlug() {
      if (this.model) {
        let slug = this.model.slug;
        if (slug === 'hydra' || slug === 'e-hydra') {
          let titles = ['Halo', 'Diode'];
          return slug + titles[Math.floor(Math.random() * titles.length)]
        }

        slug = slug.replace("e-", "")

        if (this.isMuscular) {
          slug += ".muscular"
        }

        console.log("Compare Model Slug", slug)

        return slug
      }

      return null
    },
    isAryon() {
      return this.modelSlug === 'aryon' || this.modelSlug === 'aryon-sc'
    },
    carouselModels() {
      if (this.model) {
        return this.models.filter(item => {
          return item.slug !== this.model.slug
        }).sort((a, b) => {
          return a['sort_order'] - b['sort_order']
        })
      }
      return this.models
    },
    compareText() {
      if (this.isMobileOrTablet) {
        return 'Add to compare'
      }
      return 'Add bike to compare'
    },
    compareSubText() {
      if (this.isMobileOrTablet) {
        return 'More models'
      }
      return 'Choose your model'
    },
    sortedModels() {
      return this.models.sort((a, b) => {
        return a.price - b.price
      })
    },
    sortedSpecs() {
      return this.compareBuild1.specs.sort((a, b) => {
        if (a.highlight && !b.highlight) {
          return 1
        } else if (!a.highlight && b.highlight) {
          return -1
        } else {
          return 0
        }
      }).sort((a, b) => {
        return a['sort_order'] - b['sort_order']
      }).filter(item => {
        return item.title !== null || item.description !== null
      })
    },
    selectorTitle() {
      if (this.compareBuild1 !== null) {
        return this.compareBuild1['build_title'].title
      }
      return 'Add bike to compare'
    },
    selectorSubTitle() {
      if (this.selectedTitle) {
        return 'Polar Lights'
      }
      if (this.isMobileOrTablet) {
        return 'More models'
      }
      return 'Choose your model'
    },
    showAddingCompareModelCard() {
      return this.compareBuild2 === null || this.compareBuild3 === null
    },
    fixedScrollValue() {
      let geometry = this.geometry
      let height = 0
      if (geometry) {
        height = geometry.clientHeight
      }
      return 150 + height
    },
    titleThreshold() {
      let geometryHeight
      if (!this.short) {
        geometryHeight = 0
      } else {
        geometryHeight = this.geometryHeight
      }
      let secondTitleHeight = this.secondTitleHeight;
      if (this.short) {
        secondTitleHeight += 87
      } else {
        secondTitleHeight += 40
      }
      return this.headerHeight + geometryHeight + secondTitleHeight + this.titleHeight - this.fixedThreshold
    },
    titleClass() {
      if (this.titleThreshold <= 0) {
        return {
          fixed: true
        }
      }
      return {
        fixed: this.lastScrollPosition < this.titleThreshold
      }
    },
    secondTitleStyles() {
      return {
        paddingTop: this.short ? '30px' : '1px'
      }
    },
    cardSectionClass() {
      return {
        fixed: !this.titleClass.fixed,
        collapsed: this.marginBottom !== 0 && this.cardCenterHeight <= Math.abs(this.marginBottom)
      }
    },
    isMobileOrTablet() {
      return this.isMobile || this.$device.isTablet
    },
    isMobile() {
      return (this.$device.isMobile || this.$device.isIOS) && this.screenWidth < 768
    },
    isTablet() {
      return this.$device.isTablet
    },
    cardTop() {
      return {
        top: !this.titleClass.fixed ? this.headerHeight + 'px' : 0
      }
    },
    marginThreshold() {
      if (this.$device.isMobile) {
        return 1083
      }
      return 985
    },
    cardSectionStyle() {
      return {
        marginTop: this.marginBottom + 'px',
        position: 'relative'
      }
    },
    specStyles() {
      let padding = 0
      if (!this.titleClass.fixed) {
        padding = parseFloat(this.defaultCardHeight) + this.headerHeight
        if (this.isMobileOrTablet) {
          padding -= 70
        }
      }
      return {
        paddingTop: padding + 'px'
      }
    },
    titleStyle() {
      return {
        top: this.titleTop + 'px'
      }
    },
    fixedThreshold() {
      if (this.isMobile) {
        return 20
      }
      return 13
    }
  },
  mounted() {
    this.screenWidth = window.innerWidth
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    window.scrollTo({top: 0, left: 0, behavior: 'auto'})
    setTimeout(() => {
      this.initValues()
    }, 100)
    this.lastScrollPosition = window.pageYOffset || document.documentElement.scrollTop
    window.addEventListener('scroll', this.handleScroll)
    this.$store.commit('build/selectCompareBuild', {
      type: 1,
      build: {...this.minBuild}
    });

    if (this.midBuild) {
      this.$store.commit('build/selectCompareBuild', {
        type: 2,
        build: {...this.midBuild}
      });
    }

    if (this.maxBuild) {
      this.$store.commit('build/selectCompareBuild', {
        type: this.midBuild ? 3 : 2,
        build: {...this.maxBuild}
      });
    }
    setTimeout(() => {
      this.setMaxHeight();
    }, 100)
    this.$root.$on('changeZoomBuild', data => {
      let build
      let model = this.sortedModels.find(item => {
        return item.id === data.build['model_id']
      })
      for (let item of model['builds']) {
        if (item['build_title'].id === data.title.id && data.color === null) {
          build = item
          break;
        } else if (item['build_title'].id === data.title.id && item.color.id === data.color.id) {
          build = item
          break;
        }
      }
      if (build) {
        this.$store.commit('build/setBuildForZoom', build)
        this.$store.commit('build/setBuildGroups', this.modelColorGroups(build))
        this.$store.commit('build/setBuildTitles', this.shortModelList(build))
        this.$store.commit('build/setNotRedirectFromZoom', false)
      }
      this.handleScroll()
    })
  },
  methods: {
    commonTitle(spec) {
      return this.trans[spec['common_title']]
    },
    modelTitle(tab) {
      if (tab === 'first') {
        if (this.modelSlug === 'aryon') {
          return 'Geometry Aryon'
        } else {
          return 'Geometry Aryon SC'
        }
      } else {
        if (this.modelSlug === 'aryon') {
          return 'Geometry Aryon SC'
        } else {
          return 'Geometry Aryon'
        }
      }
    },
    activeTabClass(tab) {
      return {
        active: this.tabs[tab]
      }
    },
    selectTab(tab) {
      for (let key of Object.keys(this.tabs)) {
        this.tabs[key] = false
      }
      this.tabs[tab] = true;
    },
    aryonModelSlug(other = false) {
      if (other) {
        return this.modelSlug === 'aryon' ? 'aryon-sc' : 'aryon'
      }

      return this.modelSlug
    },
    sortedTitles(model) {
      if (model.model !== 'Siryon') {
        return model.titles
      }

      let items = model.titles;
      let result = [];
      let sorting = ['Halo', 'Neon', 'Diode', 'Edition one', 'Frame Kit'];

      sorting.forEach(function (key) {
        let found = false;
        items = items.filter((item) => {
          if (!found && item.title === key) {
            result.push(item);
            found = true;
            return false;
          } else
            return true;
        })
      })
      return result
    },
    animateCompareCards() {
      let geometryHeight
      if (!this.short) {
        geometryHeight = 0
      } else {
        geometryHeight = this.geometryHeight
      }
      let cardPosition = this.headerHeight + geometryHeight + this.secondTitleHeight + this.titleHeight - 10
      let cardFooterPosition = this.cardElement.getBoundingClientRect().top + window.screenY;
      let cardFooterBottomPosition = this.cardElement.getBoundingClientRect().bottom + window.screenY;
      let cardFooterHeight = this.cardElement.getBoundingClientRect().height;
      let specPosition = this.specElement.getBoundingClientRect().top + window.screenY;
      let specBottom = this.specElement.getBoundingClientRect().bottom + window.screenY;

      if (this.isMobile) {
        let fixedPanel = document.getElementsByClassName('group-fix-btn')[0]
        let computedStyles = window.getComputedStyle(fixedPanel)
        if (this.cardSection.getBoundingClientRect().y < this.lastScrollPosition) {
          let marginBottom = parseInt(computedStyles.getPropertyValue('margin-bottom'))
          if (this.scrollDirection === 'down') {
            marginBottom -= this.scrollDiff
            if (marginBottom > 0) {
              marginBottom = 0
            }
          } else {
            marginBottom -= this.scrollDiff
            if (marginBottom < -100) {
              marginBottom = -116
            }
          }
          fixedPanel.style.marginBottom = marginBottom + 'px'
        }
      }
      if (this.cardSection.classList.contains('fixed') && this.lastScrollPosition > 1000) {
        let top = parseInt(this.cardSection.style.top)
        if (cardFooterBottomPosition >= specBottom) {
          if (this.scrollDirection === 'down') {
            top += this.scrollDiff
          } else {
            top -= this.scrollDiff
          }
          this.cardSection.style.top = top + 'px'
        }

        if (this.scrollDirection === 'up' && top < this.headerHeight) {
          top += this.scrollDiff
          if (top > this.headerHeight) {
            top = this.headerHeight
          }
          this.cardSection.style.top = top + 'px'
        }
      }

      if (this.scrollDirection === 'down' && this.currentScrollPosition > cardPosition) {
        this.currentCardHeight += this.scrollDiff
        if (this.currentCardHeight < 0) {
          this.currentCardHeight = 0
        } else {
          this.marginBottom += this.scrollDiff
        }
        if (this.currentScrollPosition >= this.marginThreshold + this.cardCenterHeight) {
          this.marginBottom = -this.cardCenterHeight
        }
      } else if (this.scrollDirection === 'up' && this.currentScrollPosition > cardPosition) {
        if ((cardFooterPosition + cardFooterHeight + 80) < specPosition) {
          this.marginBottom += this.scrollDiff
          if (this.marginBottom > 0) {
            this.marginBottom = 0
          }
        }

        this.currentCardHeight += this.scrollDiff
        if (this.currentCardHeight > this.cardCenterHeight) {
          this.currentCardHeight = this.cardCenterHeight
        }
      } else if (this.scrollDirection === 'up' && this.currentScrollPosition < cardPosition) {
        this.marginBottom = 0
        this.currentCardHeight = this.cardCenterHeight
        if (cardFooterPosition + cardFooterHeight < specPosition) {
          this.marginBottom += this.scrollDiff
          if (this.marginBottom > 0) {
            this.marginBottom = 0
          }
        }
      }
    },
    animateHeaderTitle() {
      let geometryHeight
      if (!this.short) {
        geometryHeight = 0
      } else {
        geometryHeight = this.geometryHeight
      }
      let titlePosition = this.headerHeight + geometryHeight + this.secondTitleHeight - 20;
      if (this.currentScrollPosition > titlePosition && this.currentScrollPosition < titlePosition + this.titleHeight) {
        this.titleTop = parseInt(this.title.style.top) + this.scrollDiff
        if (this.scrollDirection === 'up') {
          if (this.titleTop >= this.headerHeight) {
            this.titleTop = this.headerHeight
          }
        } else {
          if (this.titleTop <= 0) {
            this.titleTop = 0
          }
        }
      } else {
        if (this.currentScrollPosition > titlePosition) {
          this.titleTop = 0
        } else {
          this.titleTop = this.headerHeight
        }
      }
    },
    setScrollDiff() {
      this.scrollDiff = this.lastScrollPosition - this.currentScrollPosition
    },
    setScrollPositions() {
      this.currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      if (this.currentScrollPosition > this.lastScrollPosition) {
        this.scrollDirection = 'down'
      } else {
        this.scrollDirection = 'up'
      }
    },
    setUsedElements() {
      if (!this.cardElement) {
        this.cardElement = document.getElementsByClassName('cardComp-f')[0]
      }
      if (!this.specElement) {
        this.specElement = document.getElementById('gridWrapper')
      }
      if (!this.short) {
        this.geometryHeight = 0
      } else {
        this.geometryHeight = this.geometry.clientHeight
      }
      if (!this.cardSection) {
        this.cardSection = document.getElementsByClassName('cards-section')[0]
      }
    },
    setCurrentMaxHeight() {
      if (this.currentCardHeight === null) {
        let cards = document.getElementsByClassName('cardComp-c');
        let max = 0
        for (let card of cards) {
          if (card.clientHeight > max) {
            max = card.clientHeight
          }
        }
        this.cardCenterHeight = max
        this.marginBottom = 0
        this.currentCardHeight = max
      }
    },
    toContacts(number) {
      let build = this[`compareBuild${number}`];
      if (build) {
        return `/en/contact?subject=${build['model_title']} out of stock`
      } else {
        return '/en/contact'
      }
    },
    specIcon(spec) {
      let specTitle = spec['common_title'].toLowerCase().replace('/', '-');
      return `/assets/images/spec_icons/${specTitle}.svg`
    },
    goBack() {
      if (this.referer) {
        location.href = this.referer
      } else {
        window.history.go(-1);
        return false;
      }
    },
    dropDownItemClass(item, number, model) {
      if (model) {
        return {
          selected: this[`compareBuild${number}`]['build_title'].id === item.id && this[`compareBuild${number}`]['model_id'] === model.id
        }
      } else {
        if (this[`compareBuild${number}`]) {
          return {
            selected: this[`compareBuild${number}`]['build_title'].id === item.id
          }
        }
      }

      return {};
    },
    shortModelList(number) {
      let build
      if (typeof number === 'object') {
        build = number
      } else {
        build = this[`compareBuild${number}`];
      }
      if (build) {
        let model = this.models.find(item => {
          return item.id === build['model_id']
        })
        return this.sortedTitles(model);
      }

      return []
    },
    toChoose(number) {
      let build
      if (typeof number === 'object') {
        build = number
      } else {
        build = this[`compareBuild${number}`];
      }
      location.href = `/en/choose/${build['model_title'].toLowerCase()}/${build['build_title'].title.toLowerCase()}/${build.color.slug}`
    },
    modelColorGroups(number) {
      let build
      if (typeof number === 'object') {
        build = number
      } else {
        build = this[`compareBuild${number}`];
      }
      if (build) {
        let model = {
          ...this.models.find(item => {
            return item.id === build['model_id']
          })
        }
        let groups = []
        let builds = []
        for (let group of model.groups || []) {
          groups.push({...group})
        }
        for (let build of model.builds || []) {
          builds.push({...build})
        }
        groups = groups.sort((a, b) => {
          return a.price - b.price
        })

        groups = groups.map(item => {
          item.colors = item.colors.filter(color => {
            let buildsWithThisColor = builds.filter(b => {
              return b['build_title'].id === build['build_title'].id
            })

            return buildsWithThisColor.filter(bs => {
              return bs.color.id === color.id
            }).length > 0
          });
          return item
        }).filter(group => {
          return group.colors.length > 0
        })

        return groups
      }
      return []
    },
    showGallery(number) {
      this.$store.commit('build/setBuildForZoom', this[`compareBuild${number}`])
      this.$store.commit('build/setBuildGroups', this.modelColorGroups(number))
      this.$store.commit('build/setBuildTitles', this.shortModelList(number))
      this.$nextTick(() => {
        this.$modal.show('your-bag-gallery')
      })
    },
    buildImage(number) {
      return this[`compareBuild${number}`].media.preview
    },
    buildTitle(number) {
      return this[`compareBuild${number}`]['build_title'].title
    },
    hiddenCard(number) {
      return {
        hidden: !this.showCard(number)
      }
    },
    showCard(number) {
      if (number === 2 && this.isMobileOrTablet) {
        return false
      }
      return this[`compareBuild${number}`] !== null
    },
    selectNext(model, title) {
      let build = model['builds'].find(item => {
        return item['build_title'].id === title.id
      })
      if (this.compareBuild2 === null && !this.isMobileOrTablet) {
        this.$store.commit('build/selectCompareBuild', {
          type: 2,
          build: {...build}
        });
      } else {
        this.$store.commit('build/selectCompareBuild', {
          type: 3,
          build: {...build}
        });
      }
      setTimeout(() => {
        this.setMaxHeight();
      }, 400)
      this.dropDowns[4] = false
    },
    selectBuild(model, title, number) {
      if (model === null) {
        if (this[`compareBuild${number}`]) {
          let build = this[`compareBuild${number}`]
          let model = this.models.find(item => {
            return item.id === build['model_id']
          })
          let selectedBuild = model['builds'].find(build => {
            return build['build_title'].id === title.id
          })
          this.$store.commit('build/selectCompareBuild', {
            type: number,
            build: {...selectedBuild}
          });
          setTimeout(() => {
            this.setMaxHeight();
          }, 400)
        }

        return []
      } else {
        let build = model['builds'].find(build => {
          return build['build_title'].id === title.id
        })
        this.$store.commit('build/selectCompareBuild', {
          type: number,
          build: {...build}
        });

        setTimeout(() => {
          this.setMaxHeight();
        }, 400)
      }
      this.dropDowns[number] = false
    },
    specColumnClass(spec) {
      return {
        'x-3': this.sameSpec(spec)
      }
    },
    sameWithSecondAndNotSameWithThird(spec) {
      if (!this.compareBuild2 && !this.compareBuild3) {
        return false
      }

      let exist2 = !!this.compareBuild2
      let exist3 = !!this.compareBuild3

      if (exist2 && !exist3) {
        return false
      } else if (!exist2 && exist3) {
        let sameSpec3 = this.getSameSpec(spec, 3);
        return sameSpec3.title === spec.title && sameSpec3.description === spec.description
      } else {
        let sameSpec2 = this.getSameSpec(spec, 2);
        let sameSpec3 = this.getSameSpec(spec, 3);
        if (sameSpec2 && sameSpec3) {
          return sameSpec2.title === spec.title
            && sameSpec2.description === spec.description
            && (sameSpec3.title !== spec.title
              && sameSpec3.description !== spec.description)
        } else {
          return false
        }
      }
    },
    sameSpec(spec) {
      if (!this.compareBuild2 && !this.compareBuild3) {
        return true
      }

      let exist2 = !!this.compareBuild2
      let exist3 = !!this.compareBuild3

      if (exist2 && !exist3) {
        let sameSpec2 = this.getSameSpec(spec, 2);
        return sameSpec2.title === spec.title && sameSpec2.description === spec.description
      } else if (!exist2 && exist3) {
        let sameSpec3 = this.getSameSpec(spec, 3);
        return sameSpec3.title === spec.title && sameSpec3.description === spec.description
      } else {
        let sameSpec2 = this.getSameSpec(spec, 2);
        let sameSpec3 = this.getSameSpec(spec, 3);
        if (sameSpec2 && sameSpec3) {
          return sameSpec2.title === spec.title
            && sameSpec2.description === spec.description
            && sameSpec3.title === spec.title
            && sameSpec3.description === spec.description
        } else {
          return false
        }
      }
    },
    hasSameSpec(spec, number) {
      return this[`compareBuild${number}`] !== null
        && this.getSameSpec(spec, number) !== undefined
    },
    notSameContent(spec, number) {
      let same = this.getSameSpec(spec, number)
      if (same !== undefined) {
        return same.title !== spec.title
          || same.description !== spec.description
      }

      return false
    },
    notSameWithBefore(spec, number1, number2) {
      let spec2
      if (this.isMobile) {
        spec2 = this.getSameSpec(spec, 1)
      } else {
        spec2 = this.getSameSpec(spec, number1)
      }
      let spec3 = this.getSameSpec(spec, number2)
      if (!spec2 || !spec3) {
        return true
      }

      return spec2.title !== spec3.title || spec2.description !== spec3.description
    },
    showCardColumn(spec, number) {
      if (number === 2 && this.isMobile) {
        return false
      }
      return (this.hasSameSpec(spec, number) && this.notSameContent(spec, number))
        || !this.hasSameSpec(spec, number)
    },
    specDescription(spec, number) {
      let find = this.getSameSpec(spec, number);
      if (find) {
        return find.description
      }

      return null
    },
    specTitle(spec, number) {
      let find = this.getSameSpec(spec, number);
      if (find) {
        return find.title
      }

      return null
    },
    getSameSpec(spec, number) {
      if (this[`compareBuild${number}`] === null) {
        return undefined
      }
      return this[`compareBuild${number}`].specs.find(item => {
        return item['common_title'] === spec['common_title']
      })
    },
    specTitleClass(spec) {
      if (spec) {
        return {
          'color-gray': spec.highlight,
          'color-black': !spec.highlight,
          'bold': !spec.highlight,
        }
      }
      return {}
    },
    specDescriptionClass(spec) {
      if (spec) {
        return {
          'fs-24': spec.highlight,
          bold: spec.highlight,
          'fs-17': !spec.highlight,
          'color-dark': !spec.highlight,
        }
      }

      return {}
    },
    titles(model) {
      return model['titles'];
    },
    setMaxHeight() {
      let maxHeight = 308
      let cards = document.getElementsByClassName('cardComp-c');
      if (this.isMobile) {
        let maxGroupsLength = 0;
        for (let number of [1, 3]) {
          let groupLength = this.modelColorGroups(number).length;
          if (groupLength > maxGroupsLength) {
            maxGroupsLength = groupLength
          }
        }
        if (maxGroupsLength > 1 && this.isMobile) {
          maxHeight += (60 * (maxGroupsLength - 1));
        }
      } else {
        for (let card of cards) {
          let height = card.getBoundingClientRect().height;
          if (height > maxHeight) {
            maxHeight = height
          }
        }
      }

      for (let card of cards) {
        card.style.height = maxHeight + 'px'
      }
      this.cardCenterHeight = maxHeight
      this.cardHeight = maxHeight
    },
    showDropDown(event, number) {
      if (event.target.localName !== 'li' && event.target.localName !== 'span') {
        this.dropDowns[number] = !this.dropDowns[number]
      }
    },
    dropDownActive(number) {
      return {
        active: this.dropDowns[number]
      }
    },
    handleScroll() {
      this.setUsedElements()

      this.cardHeight = this.cardSection.clientHeight + this.headerHeight

      this.setScrollPositions()

      this.setScrollDiff()

      this.animateHeaderTitle()

      this.setCurrentMaxHeight()

      this.animateCompareCards()

      this.lastScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    },
    isColorChecked(number, color) {
      if (this[`compareBuild${number}`]) {
        return this[`compareBuild${number}`].color.id === color.id
      }

      return false;
    },
    buildPrice(number) {
      if (this[`compareBuild${number}`]) {
        let build = this[`compareBuild${number}`]
        let euCountry = build.country_taxes.find(country => {
          return country.tax_percent === 21
        })
        return euCountry.price;
      }

      return 0
    },
    modelLink(number) {
      if (this[`compareBuild${number}`]) {
        let build = this[`compareBuild${number}`]
        let model = this.models.find(item => {
          return item.id === build['model_id']
        })

        return `/en/products/${model.slug}`;
      }

      return null
    },
    outOfStock(number) {
      if (this[`compareBuild${number}`]) {
        let build = this[`compareBuild${number}`]
        return build.blocked;
      }

      return true
    },
    selectBuildByColor(color, number) {
      if (this[`compareBuild${number}`]) {
        let build = this[`compareBuild${number}`];
        let model = this.models.find(item => {
          return item.id === build['model_id']
        })

        let newBuild = model['builds'].find(item => {
          return item.color.id === color.id
            && item['build_title'].id === build['build_title']['id']
        })

        this.$store.commit('build/selectCompareBuild', {
          type: number,
          build: {...newBuild}
        });
      }
    },
    initValues() {
      this.title = document.getElementsByClassName('fixTopLine')
      this.secondTitle = document.getElementsByClassName('second-title')[0]
      this.header = document.getElementsByClassName('header')[0]
      this.geometry = document.getElementsByClassName('geometry-section')
      if (this.title.length > 0) {
        this.title = this.title[0]
        this.titleHeight = this.title.clientHeight
      } else {
        this.titleHeight = 0
      }
      if (this.geometry.length > 0) {
        this.geometry = this.geometry[0]
        if (!this.short) {
          this.geometryHeight = 0
        } else {
          this.geometryHeight = this.geometry.clientHeight
        }
      } else {
        this.geometryHeight = 0
      }
      this.secondTitleHeight = this.secondTitle.clientHeight
      this.headerHeight = this.header.clientHeight
      this.cardSection = document.getElementsByClassName('cards-section')[0]
      this.cardHeight = this.cardSection.clientHeight
      this.defaultCardHeight = this.cardSection.clientHeight + 80
      this.titleTop = this.headerHeight
    },
    colorGroupPrice(group) {
      if (group.price === 0) {
        return ''
      }
      return this.$crConverter(group.price / 100, 'EUR', '%s +%v')
    }
  },
}

</script>
<style lang="scss">
.fixTopLine {
  width: 100%;
  top: 80px;
  z-index: 10;
  padding: 11px 0;
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  backdrop-filter: saturate(180%) blur(20px);
  background-color: hsla(0, 0%, 100%, .85);
  opacity: 0;
  visibility: hidden;

  &.fixed {
    position: fixed;
    opacity: 1;
    visibility: inherit;
  }

  .flex {
    display: flex;
    align-items: center;

    .nav-tabs {
      padding: 0;
      margin: 0;
      display: flex;
      align-items: flex-start;

      .nav-item {
        margin: 0 40px 0 0;
        height: 38px;
        display: flex;
        align-items: center;

        .nav-link {
          display: inline-block;
          font-weight: normal;
          font-size: 24px;
          line-height: 48px;
          color: #000000;
          position: relative;
          text-decoration: none;
          cursor: pointer;
          margin: 0;

          &.active {
            font-weight: bold;
            cursor: default;

            &:before {
              opacity: 1;
            }
          }

          &:before {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 4px;
            background: #c2e900;
            border-radius: 24px;
            opacity: 0;
          }
        }
      }

      @media (min-width: 767px) {
        & ~ .fs-24 {
          display: none;
        }
      }

    }

    .fs-24 {
      margin: 0 auto 0 0;
    }

    .btn {
      height: 38px;
      width: 130px;
      margin-left: 16px;
      border-radius: 7px;
      padding-left: 4px;
      padding-right: 4px;
    }
  }

  @media (max-width: 991px) {
    .flex {
      .nav-tabs {
        padding: 0;
        margin: 0;
        display: flex;
        align-items: flex-start;

        .nav-item {
          margin: 0 20px 0 0;

          .nav-link {
            font-size: 20px;
            line-height: 40px;
          }
        }

        @media (min-width: 767px) {
          & ~ .fs-24 {
            display: none;
          }
        }

      }
    }
  }
  @media (max-width: 767px) {
    background-color: hsla(0, 0%, 96.1%, .85);
    .flex {
      .fs-24 {
        font-size: 13px;
      }

      .btn {
        height: 26px;
        width: 98px;
        padding-left: 8px;
        padding-right: 8px;
        margin-left: 16px;
        border-radius: 7px;
        font-size: 13px;
      }
    }
  }
}

.frame-wrapper {
  position: relative;
  display: flex;
  margin-bottom: 75px;
  &.fixed {
    position: fixed;
  }

  .fs-36 {
    margin: 135px 0 -40px;
  }


  @media (min-width: 767px) {
    &:first-child {
      margin-top: 96px;
    }
  }
  @media (max-width: 991px) {
    margin-bottom: 60px;
    .fs-36 {
      margin: 120px 0 32px;
    }
  }
  @media (max-width: 767px) {
    margin-bottom: 50px;
    .fs-36 {
      margin: 94px 0 24px;
    }
  }
}

.comparison-wrapper {
  &.fixed {
    position: fixed;
    width: 100%;
    z-index: 990;

    &.stop {
      position: sticky;
      margin: -1px 0 60px;
      @media (max-width: 767px) {
        margin: -1px 0 48px;
      }
    }
  }

  .titleWrap {
    padding: 0;
    margin: 12px 0 80px;
    @media (max-width: 991px) {
      margin: 12px 0 70px;
    }
    @media (max-width: 575px) {
      margin: 0 0 50px -24px;
      background: #F5F5F5;
      width: calc(100% + 40px);
      padding: 11px 20px;
      .btn {
        margin: 0;
        padding: 0;
        height: 26px;
        background-color: transparent;
        color: #000;
        font-weight: normal;
        font-size: 13px;
        line-height: 13px;
        width: auto;
      }
      .fs-24 {
        font-size: 13px;
      }
    }
  }

  @media (max-width: 767px) {
    &.fixed {
      margin-top: 1px;

      //.cardComp-h {
      //  border-bottom-color: transparent;
      //}
    }
    &.collapsed {
      .cardComp-h {
        border-bottom-color: transparent;
      }
    }
  }
}

.second-title {
  margin-bottom: 53px;

  &:first-child {
    margin-top: 105px;
    @media (max-width: 991px) {
      margin-top: 90px;
    }
    @media (max-width: 767px) {
      margin-top: 64px;
    }
  }

  .fs-36 {
    margin: 0;
  }

  @media (max-width: 767px) {
    margin-bottom: 30px;
    .fs-36 {
      margin-bottom: 0;
    }
  }
  @media (max-width: 350px) {
    margin-bottom: 20px;
  }

}


@media (min-width: 768px) {
  .desktop-hide {
    display: none !important;
  }
}

@media (max-width: 767px) {
  .mobile-hide {
    display: none !important;
  }
}
</style>

